import { RootState } from '../../reducers';

export const getRoles = (state: RootState) => state.application.common.roles || [];
